import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPasswordRecoveryStatus = createSelector(
  [(store: RootState) => store.userAuthentication.passwordRecoveryStatus],
  (show) => show
);
